export default "__VITE_ASSET__DixQvjnV__"